var Timer = /** @class */ (function () {
    function Timer(fn, time) {
        this.fn = fn;
        this.time = time;
        this.interval = setInterval(fn, time);
    }
    Timer.prototype.stop = function () {
        if (this.interval) {
            clearInterval(this.interval);
            this.interval = null;
        }
        return this;
    };
    Timer.prototype.start = function () {
        if (!this.interval) {
            this.stop();
            this.interval = setInterval(this.fn, this.time);
        }
        return this;
    };
    Timer.prototype.reset = function (time) {
        this.time = time;
        return this.stop().start();
    };
    return Timer;
}());
export default Timer;
